import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

type Variant = 'primary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  fullWidth = false,
  ...rest
}) => (
  <Container data-variant={variant} data-fullwidth={fullWidth} {...rest}>
    {children}
  </Container>
);

export default Button;
